import { render, staticRenderFns } from "./modelInfo.vue?vue&type=template&id=15284856&scoped=true&"
import script from "./modelInfo.vue?vue&type=script&lang=js&"
export * from "./modelInfo.vue?vue&type=script&lang=js&"
import style0 from "./modelInfo.vue?vue&type=style&index=0&id=15284856&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15284856",
  null
  
)

export default component.exports